(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:onRightClick
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="commons">
       <file name="index.html">
        <on-right-click></on-right-click>
       </file>
     </example>
   *
   */
  angular
    .module('commons')
    .directive('onRightClick', onRightClick);

  function onRightClick($parse) {
    return {
      restrict: 'A',
      scope : false,
      replace: false,
      controllerAs: 'onRightClick',
      controller: function () {
        var vm = this;
        vm.name = 'onRightClick';
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
        var callBack =  $parse(attrs.onRightClick);
        element.bind('contextmenu', function(event) {
          scope.$apply(function() {
            event.preventDefault();
            callBack(scope, {clickedScope:scope});
          });
        });
      }
    };
  }
}());
